<template>
         <!-- Sidebar -->
         <div class="offcanvas-lg offcanvas-start bg-sa-sidebar text-white flex-shrink-0 col-lg-2 p-0 glass" tabindex="-1" id="sidebar" aria-labelledby="sidebarLabel">
            <div class="offcanvas-header d-lg-none">
               <h5 class="offcanvas-title" id="sidebarLabel">Admin Panel</h5>
               <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"></button>
            </div>
            <div class="offcanvas-body p-0">
               <ul class="nav flex-column mb-auto col-12">
                  <!-- Profile Dropdown -->
                  <li class="nav-item mb-0 border-bottom" id="userMenu">
                     <div class="dropdown">
                        <a class="d-flex align-items-center text-white text-decoration-none dropdown-toggle py-2 px-3" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <!--<img class="sidebar_user" src="/img/sunny.png">-->
                        <!--<img class="sidebar_user" :src="userPic ? `${$baseUrl}/users/${userPic}` : '/img/sunny.png'" alt="User Image" />-->
                        <img class="sidebar_user" :src="userPic ? `${$baseUrl}/users/${userPic}` : '/img/sunny.png'" @error="$event.target.src = '/img/sunny.png'" alt="User Image"/>
                        <span class="d-flex flex-column overflow-hidden">
                           <span class="sidebar-user-name" :title="userName">{{ userName }}</span>
                           <small v-if="roleName" class="sidebar-user-role" :title="roleName">{{ roleName }}</small>
                        </span>
                        </a>
                        <ul
   class="dropdown-menu dropdown-menu-dark"
   data-bs-auto-close="outside">

   <!-- Profile -->
   <li>
      <a class="dropdown-item" href="#">
         <i class="fa fa-user me-2"></i>
         Profile
      </a>
   </li>
   <!-- Subscriotion -->
   <li>
    <router-link to="/profile/my_subscription/" class="dropdown-item" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
       <i class="fa fa-credit-card me-2"></i>My Subscription
    </router-link>
   </li>

   <!-- Settings -->
   <li>
      <a class="dropdown-item" href="#">
         <i class="fa fa-cog me-2"></i>
         Settings
      </a>
   </li>

   <li>
      <hr class="dropdown-divider">
   </li>

   <!-- Company Dropdown -->
<li class="border-bottom">
    <a href="#"
       class="dropdown-item d-flex align-items-center justify-content-between"
       @click.prevent.stop="toggleCompanyDropdown">

        <span>
            <i class="bi bi-building me-2"></i>
            Company
        </span>

      <i class="bi" :class="showCompanyDropdown ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
    </a>

    <div v-if="showCompanyDropdown" class="px-2 pb-2">

        <div v-if="userCompanies.length === 0"
             class="text-muted small px-3 py-2">
            No companies assigned.
        </div>

        <a
            v-for="company in userCompanies"
            :key="company.id"
            href="#"
            class="dropdown-item ps-4 d-flex align-items-center justify-content-between"
            @click.prevent.stop="selectCompany(company)"
        >

                        <span class="menu-name" :title="company.company_name">
                {{ company.company_name }}
            </span>

            <i
                v-if="Number(company.id) === Number(companyId)"
                class="bi bi-check text-success fs-5"
            ></i>

        </a>

    </div>
</li>


   <!-- Branch Dropdown -->
   <li class="border-bottom">
    <a href="#"
       class="dropdown-item d-flex align-items-center justify-content-between"
       @click.prevent.stop="toggleBranchDropdown">

        <span>
            <i class="bi bi-geo-alt me-2"></i>
            Branch
        </span>

        <i
             class="bi"
             :class="showBranchDropdown ? 'bi-chevron-up' : 'bi-chevron-down'"
         ></i>

    </a>

    <div v-if="showBranchDropdown" class="px-2 pb-2">

        <div v-if="!selectedCompany"
             class="text-muted small px-3 py-2">
            <span class="sa-core-color">No company selected.</span>
        </div>

        <div
            v-else-if="selectedCompanyBranches.length === 0"
            class="text-muted small px-3 py-2"
        >
            <span class="sa-core-color">No branches assigned.</span>
        </div>

        <a
            v-for="branch in selectedCompanyBranches"
            :key="branch.id"
            href="#"
            class="dropdown-item ps-4 d-flex align-items-center justify-content-between"
            :class="{
                'disabled opacity-50':
                    switchingCompanyBranch
            }"
            @click.prevent.stop="switchCompanyBranch(branch)"
        >

                        <span class="sa-core-color menu-name" :title="branch.branch_name">
                {{ branch.branch_name }}

                <small
                    v-if="branch.is_head_office == 1"
                    class="sa-core-color ms-1"
                >
                    (HQ)
                </small>
            </span>

            <i
                v-if="
                    Number(selectedCompanyId) === Number(companyId) &&
                    (
                        branch.is_all_branches
                            ? branchId === null || branchId === undefined
                            : Number(branch.id) === Number(branchId)
                    )
                "
                class="bi bi-check text-success fs-5"
            ></i>

        </a>

    </div>
</li>


   <li>
      <hr class="dropdown-divider">
   </li>


   <!-- Logout -->
   <li>
      <a
         class="dropdown-item"
         href="#"
         data-bs-toggle="modal"
         data-bs-target="#logOutModal">

         <i class="fa fa-sign-out me-2"></i>
         Logout

      </a>
   </li>

</ul>
                     </div>
                  </li>
                  

                                    <!-- Dashboard -->
                  <li class="nav-item">
                     <router-link to="/dashboard/" class="nav-link" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                        <span class="menu-item-parent">
                           <i class="fa fa-lg fa-fw fa-home"></i>
                           Dashboard
                        </span>
                     </router-link>
                  </li>

                  <!-- Sales & Invoicing (demo: pages come later, so they are marked "Soon") -->
                  <li v-show="showSales()">
                     <a class="nav-link text-white level-toggle d-flex justify-content-between align-items-center"
                        data-bs-toggle="collapse" href="#salesMenu" role="button" aria-expanded="false">
                        <span class="menu-item-parent">
                           <i class="fa fa-lg fa-fw fa-shopping-cart"></i>
                           SALES & INVOICING
                        </span>
                        <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                     </a>
                     <div class="collapse level1" id="salesMenu" data-bs-parent="#sidebar">
                        <ul class="nav flex-column w-100 sa-tree">
                           <li class="nav-item"><a href="#" class="nav-link text-white level-toggle" @click.prevent><i class="fa fa-fw fa-file-text me-1"></i>Customers <span class="badge bg-secondary ms-1">Soon</span></a></li>
                           <li class="nav-item"><a href="#" class="nav-link text-white level-toggle" @click.prevent><i class="fa fa-fw fa-file-text me-1"></i>Products & Services <span class="badge bg-secondary ms-1">Soon</span></a></li>
                           <li class="nav-item"><a href="#" class="nav-link text-white level-toggle" @click.prevent><i class="fa fa-fw fa-file-text me-1"></i>Quotes <span class="badge bg-secondary ms-1">Soon</span></a></li>
                           <li class="nav-item"><a href="#" class="nav-link text-white level-toggle" @click.prevent><i class="fa fa-fw fa-file-text me-1"></i>Invoices <span class="badge bg-secondary ms-1">Soon</span></a></li>
                           <li class="nav-item"><a href="#" class="nav-link text-white level-toggle" @click.prevent><i class="fa fa-fw fa-file-text me-1"></i>Payments Received <span class="badge bg-secondary ms-1">Soon</span></a></li>
                           <li class="nav-item"><a href="#" class="nav-link text-white level-toggle" @click.prevent><i class="fa fa-fw fa-file-text me-1"></i>Receipts <span class="badge bg-secondary ms-1">Soon</span></a></li>
                        </ul>
                     </div>
                  </li>

                  <!-- Samples (department groups like Finance, HR are added at this same level) -->
                  <li v-show="showSamples()">
                     <a class="nav-link text-white level-toggle d-flex justify-content-between align-items-center"
                        data-bs-toggle="collapse" href="#samplesMenu" role="button" aria-expanded="false">
                        <span class="menu-item-parent">
                           <i class="fa fa-lg fa-fw fa-flask"></i>
                           SAMPLES
                        </span>
                        <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                     </a>
                     <div class="collapse level1" id="samplesMenu" data-bs-parent="#sidebar">
                        <ul class="nav flex-column w-100 sa-tree">
                           <li class="nav-item" v-if="$hasPermission('crud_offline_online.view')">
                              <router-link to="/crud-offline-online/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                 <i class="fa fa-fw fa-file-text me-1"></i>CRUD Offline/Online
                                 <i v-if="isLocked('crud_offline_online.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                              </router-link>
                           </li>
                           <li class="nav-item" v-if="$hasPermission('crud_online.view')">
                              <router-link to="/crud-online-only/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                 <i class="fa fa-fw fa-file-text me-1"></i>CRUD Online Only
                                 <i v-if="isLocked('crud_online.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                              </router-link>
                           </li>

                           <!-- Multi Level Menu (demo of how deep menus look) -->
                           <li class="nav-item" v-if="$hasPermission('multi_level_menu.view')">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#mlMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-sitemap me-1"></i>Multi Level Menu</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="mlMenu" data-bs-parent="#samplesMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">

                                    <!-- Level 2 -->
                                    <li>
                                       <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                          data-bs-toggle="collapse" href="#mlLevel2" role="button" aria-expanded="false">
                                          <span><i class="fa fa-fw fa-folder me-1"></i>Level 2</span>
                                          <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                                       </a>
                                       <div class="collapse" id="mlLevel2" data-bs-parent="#mlMenu">
                                          <ul class="nav flex-column w-100 sa-tree sa-tree-2 sa-tree-3">

                                             <!-- Level 3 -->
                                             <li>
                                                <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                                   data-bs-toggle="collapse" href="#mlLevel3" role="button" aria-expanded="false">
                                                   <span><i class="fa fa-fw fa-folder me-1"></i>Level 3</span>
                                                   <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                                                </a>
                                                <div class="collapse" id="mlLevel3" data-bs-parent="#mlLevel2">
                                                   <ul class="nav flex-column w-100 sa-tree sa-tree-2 sa-tree-4">

                                                      <!-- Level 4 -->
                                                      <li>
                                                         <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                                            data-bs-toggle="collapse" href="#mlLevel4" role="button" aria-expanded="false">
                                                            <span><i class="fa fa-fw fa-folder me-1"></i>Level 4</span>
                                                            <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                                                         </a>
                                                         <div class="collapse" id="mlLevel4" data-bs-parent="#mlLevel3">
                                                            <ul class="nav flex-column w-100 sa-tree sa-tree-2 sa-tree-5">
                                                               <li>
                                                                  <a href="#" class="nav-link text-white level-toggle" @click.prevent>Item 1</a>
                                                               </li>

                                                               <!-- Item 2 (opens one more level) -->
                                                               <li>
                                                                  <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                                                     data-bs-toggle="collapse" href="#mlLevel5" role="button" aria-expanded="false">
                                                                     <span><i class="fa fa-fw fa-folder me-1"></i>Item 2</span>
                                                                     <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                                                                  </a>
                                                                  <div class="collapse" id="mlLevel5" data-bs-parent="#mlLevel4">
                                                                     <ul class="nav flex-column w-100 sa-tree sa-tree-2 sa-tree-6">
                                                                        <li>
                                                                           <a href="#" class="nav-link text-white level-toggle" @click.prevent>Item 1</a>
                                                                        </li>
                                                                        <li>
                                                                           <a href="#" class="nav-link text-white level-toggle" @click.prevent>Item 2</a>
                                                                        </li>
                                                                     </ul>
                                                                  </div>
                                                               </li>
                                                            </ul>
                                                         </div>
                                                      </li>

                                                   </ul>
                                                </div>
                                             </li>

                                          </ul>
                                       </div>
                                    </li>

                                    <!-- Level 2 other -->
                                    <li>
                                       <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                          data-bs-toggle="collapse" href="#mlLevel2b" role="button" aria-expanded="false">
                                          <span><i class="fa fa-fw fa-folder me-1"></i>Level 2 other</span>
                                          <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                                       </a>
                                       <div class="collapse" id="mlLevel2b" data-bs-parent="#mlMenu">
                                          <ul class="nav flex-column w-100 sa-tree sa-tree-2 sa-tree-3">
                                             <li>
                                                <a href="#" class="nav-link text-white level-toggle" @click.prevent>Level 3</a>
                                             </li>
                                          </ul>
                                       </div>
                                    </li>

                                 </ul>
                              </div>
                           </li>
                        </ul>
                     </div>
                  </li>

                  <!-- ADMINISTRATION -->
                  <li v-show="showAdministration()">
                     <a class="nav-link text-white level-toggle d-flex justify-content-between align-items-center"
                        data-bs-toggle="collapse" href="#adminMenu" role="button" aria-expanded="false">
                        <span class="menu-item-parent">
                           <i class="fa fa-lg fa-fw fa-shield"></i>
                           ADMINISTRATION
                        </span>
                        <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                     </a>
                     <div class="collapse level1" id="adminMenu" data-bs-parent="#sidebar">
                        <ul class="nav flex-column w-100 sa-tree">

                           <!-- Organisation -->
                           <li class="nav-item" v-if="showOrganisation()">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#organisationMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-building me-1"></i>Organisation</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="organisationMenu" data-bs-parent="#adminMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">
                                    <li v-if="$hasPermission('companies.view')">
                                       <router-link to="/settings/companies/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Companies
                                          <i v-if="isLocked('companies.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('branches.view')">
                                       <router-link to="/settings/branches/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Branches
                                          <i v-if="isLocked('branches.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                 </ul>
                              </div>
                           </li>

                           <!-- Users & Access -->
                           <li class="nav-item" v-if="showUserManagement()">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#usermanagementMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-users me-1"></i>Users & Access</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="usermanagementMenu" data-bs-parent="#adminMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">
                                    <li v-if="$hasPermission('users.view')">
                                       <router-link to="/user-management/users/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Users
                                          <i v-if="isLocked('users.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('user_company_branch_access.view')">
                                       <router-link to="/user-management/user_company_branch_access/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Branch Access
                                          <i v-if="isLocked('user_company_branch_access.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('mfa_and_location_settings.view')">
                                       <router-link to="/user-management/mfa_and_location_settings/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Login Security
                                          <i v-if="isLocked('mfa_and_location_settings.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('roles.view')">
                                       <router-link to="/user-management/roles/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Roles                                          
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('roles.view')">
                                       <router-link to="/user-management/roles-v2/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Roles Version 2
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('permissions.view')">
                                       <router-link to="/user-management/permissions/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Permissions
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('permission_categories.view')">
                                       <router-link to="/user-management/permission_categories/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Perm/App Categories
                                       </router-link>
                                    </li>
                                 </ul>
                              </div>
                           </li>

                           <!-- Settings -->
                           <li class="nav-item" v-if="showSettings()">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#settingsMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-cogs me-1"></i>Settings</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="settingsMenu" data-bs-parent="#adminMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">
                                    <li v-if="canManageModules">
                                       <router-link to="/settings/apps/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Apps
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('security_settings.view')">
                                       <router-link to="/settings/security_settings/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Security Settings
                                          <i v-if="isLocked('security_settings.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('email_settings.view')">
                                       <router-link to="/settings/email_settings/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Email Settings
                                          <i v-if="isLocked('email_settings.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('sms_settings.view')">
                                       <router-link to="/settings/sms_settings/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          SMS Settings
                                          <i v-if="isLocked('sms_settings.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('google_map_settings.view')">
                                       <router-link to="/settings/google_map_settings/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Google Maps
                                          <i v-if="isLocked('google_map_settings.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('tags.view')">
                                       <router-link to="/settings/tags/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Tags
                                          <i v-if="isLocked('tags.view')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                 </ul>
                              </div>
                           </li>

                           <!-- Data & Logs -->
                           <li class="nav-item" v-if="showDataLogs()">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#dataLogsMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-database me-1"></i>Data & Logs</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="dataLogsMenu" data-bs-parent="#adminMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">
                                    <li v-if="$hasPermission('data_migration.view')">
                                       <router-link to="/migrations/data_migration/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Data Migration
                                          <i v-if="isLocked('data_migration.view') && !$store.state.is_platform" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('audit-logs')">
                                       <router-link to="/logs/audit-logs/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Audit Logs
                                          <i v-if="isLocked('audit-logs')" class="fa fa-lock menu-lock" title="Not included in your plan"></i>
                                       </router-link>
                                    </li>
                                 </ul>
                              </div>
                           </li>

                        </ul>
                     </div>
                  </li>

                  <!-- PLATFORM (only your platform company) -->
                  <li v-show="showPlatform()">
                     <a class="nav-link text-white level-toggle d-flex justify-content-between align-items-center"
                        data-bs-toggle="collapse" href="#platformMenu" role="button" aria-expanded="false">
                        <span class="menu-item-parent">
                           <i class="fa fa-lg fa-fw fa-globe"></i>
                           PLATFORM
                        </span>
                        <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                     </a>
                     <div class="collapse level1" id="platformMenu" data-bs-parent="#sidebar">
                        <ul class="nav flex-column w-100 sa-tree">

                           <!-- Subscriptions -->
                           <li class="nav-item" v-if="showSubscription()">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#subscriptionMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-credit-card me-1"></i>Subscriptions</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="subscriptionMenu" data-bs-parent="#platformMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">
                                    <li v-if="$hasPermission('packages.view')">
                                       <router-link to="/subscription/subscription_packages/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Packages
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('packages.view')">
                                       <router-link to="/subscription/subscription_packages_v2/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Packages Version 2
                                       </router-link>
                                    </li>
                                 </ul>
                              </div>
                           </li>

                           <!-- Clients -->
                           <li class="nav-item" v-if="showClients()">
                              <a class="nav-link text-white d-flex justify-content-between align-items-center level-toggle"
                                 data-bs-toggle="collapse" href="#clientsMenu" role="button" aria-expanded="false">
                                 <span><i class="fa fa-fw fa-handshake-o me-1"></i>Clients</span>
                                 <b class="collapse-sign"><em class="fa fa-plus-square-o"></em></b>
                              </a>
                              <div class="collapse" id="clientsMenu" data-bs-parent="#platformMenu">
                                 <ul class="nav flex-column w-100 sa-tree sa-tree-2">
                                    <li v-if="$hasPermission('clients.view')">
                                       <router-link to="/clients/clients/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Clients
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('platform_modules.view')">
                                       <router-link to="/subscription/modules/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Modules
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('clients_payments.view')">
                                       <router-link to="/clients/clients_payments/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          Client Payments
                                       </router-link>
                                    </li>
                                    <li v-if="$hasPermission('user_statistics.view') && $store.state.is_platform">
                                       <router-link to="/clients/user_statistics/" class="nav-link text-white level-toggle" exact-active-class="active" aria-current="page" @click.native="collapseNavbar">
                                          User Statistics
                                       </router-link>
                                    </li>
                                 </ul>
                              </div>
                           </li>

                        </ul>
                     </div>
                  </li>


               </ul>

               <!-- Add apps: always at the bottom of the menu (Developer and Administrator only) -->
               <div v-if="canManageModules" class="sidebar-add-apps bg-sa-sidebar">
                  <button type="button" class="btn btn-sm btn-primary w-100" title="Add apps" @click="collapseNavbar(); openAppsModal(false)">
                     <i class="fa fa-plus-circle fa-fw"></i>
                     <span class="sidebar-add-apps-text">Add apps</span>
                  </button>
               </div>
            </div>
         </div>
         <!-- End Sidebar -->
         <!-- Sidebar toggle arrow -->
         <span id="sidebarCollapseArrow" class="sidebar-minify-wrapper d-none d-lg-inline">
         <i class="fa fa-lg fa-arrow-circle-left hit text-white"></i>
         <span class="sidebar-minify-rect"></span>
         </span>
         <!-- End Sidebar toggle arrow -->

         <!--logOutModal-->
      <div id="logOutModal" class="modal fade" tabindex="-1" aria-labelledby="logOutModalLabel" aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered w-100 m-0 mw-100">
      <div class="modal-content bg-sa-modal-content border-0 shadow-lg rounded-0">

         <!-- Modal Header -->
         <div class="modal-header bg-sa-modal-header justify-content-center">
   <h3 id="logOutModalLabel" class="modal-title sa-core-color mb-0 text-center">
      Are you sure you want to Log Out?
   </h3>

   <button
      type="button"
      class="btn-close color-sa-btn-close position-absolute end-0 me-3"
      data-bs-dismiss="modal"
      aria-label="Close">
   </button>
</div>

         <!-- Modal Body -->
         <div class="modal-body py-4">
            <div class="text-center">

               <h5 v-if="!isVisible" class="mb-0">
                  Are you sure you want to end your current session?
               </h5>

               <!-- Offline saves not sent yet -->
               <div v-if="!isVisible && pendingSaves > 0" class="alert alert-warning mt-3 mb-0">
                  <i class="fa fa-exclamation-triangle me-1"></i>
                  You have {{ pendingSaves }} offline save(s) that haven't been sent yet.
                  They stay on this device and will be sent the next time you log in here with internet.
               </div>

               <h4
                  v-if="isVisible"
                  class="ajax-loading-animation sa-core-color mb-0">
                  <i class="fa fa-cog fa-spin me-2"></i>
                  Logging Out...
               </h4>

            </div>
         </div>

         <!-- Modal Footer -->
         <div class="modal-footer bg-sa-modal-footer justify-content-center gap-2">

            <button
               @click="logOut();"
               type="button"
               class="btn btn-success px-4">
               <i class="fa fa-sign-out-alt me-1"></i>
               Yes
            </button>

            <button
               type="button"
               class="btn btn-default color-sa-modal_close px-4"
               data-bs-dismiss="modal">
               Close
            </button>

         </div>

      </div>
   </div>
</div>
      <!--End logOutModal-->

      <!--addAppsModal: the Apps page in a popup (button at the bottom of the menu, and the welcome after login)-->
      <div id="addAppsModal" class="modal fade" tabindex="-1" aria-labelledby="addAppsModalLabel" aria-hidden="true">
         <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content bg-sa-modal-content border-0 shadow-lg">

               <div class="modal-header bg-sa-modal-header">
                  <h5 id="addAppsModalLabel" class="modal-title sa-core-color mb-0">
                     <i class="fa fa-th-large me-2"></i>Add apps
                  </h5>
                  <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
               </div>

               <div class="modal-body">
                  <h5 v-if="appsWelcomeMode" class="sa-core-color mb-2">
                     Welcome! Pick the apps you need. You can change this anytime.
                  </h5>
                  <!-- Loaded each time the popup opens, so the switches are always current -->
                  <Apps v-if="appsModalOpen" in-modal />
               </div>

               <div class="modal-footer bg-sa-modal-footer justify-content-between">
                  <div v-if="appsWelcomeMode" class="form-check mb-0">
                     <input id="hideAppsWelcome" v-model="hideAppsWelcome" class="form-check-input" type="checkbox" @change="saveHideAppsWelcome">
                     <label class="form-check-label sa-core-color" for="hideAppsWelcome">Don't show this again</label>
                  </div>
                  <span v-else></span>
                  <button type="button" class="btn btn-default color-sa-modal_close px-4" data-bs-dismiss="modal">Close</button>
               </div>

            </div>
         </div>
      </div>
      <!--End addAppsModal-->
   
</template>
<script>
import axios from 'axios'
import emitter from '../../main.js';
import { outboxItems } from '../../offline/offlineStore.js';
import Apps from '@/views/settings/views/Apps.vue';

export default {
  name: 'Navbar',
  components: { Apps },
    data: function(){

      return {
         //allPermissions,
         isUserManagementOpen: false,
         showCompanyDropdown: false,
         showBranchDropdown: false,

         userCompanies: [],
         selectedCompanyId: null,
         switchingCompanyBranch: false,

         subscriptionPermissions: ["packages.view","packages.edit","packages.delete"],
         clientsPermissions: ["clients.view", "clients_payments.view", "user_statistics.view","platform_modules.view"],
         userManagementPermissions: ["users.view","user_company_branch_access.view","mfa_and_location_settings.view","permissions.view","permission_categories.view","roles.view"],
         samplesPermissions: ["crud_offline_online.view","crud_online.view"],
         organisationPermissions: ["companies.view","branches.view"],
         settingsPermissions: ["security_settings.view","sms_settings.view","email_settings.view","google_map_settings.view","tags.view"],
         dataLogsPermissions: ["data_migration.view","audit-logs"],
         subscriptionAccess: [], // permissions included in the company's package
         isVisible: false,
         pendingSaves: 0, // offline saves not sent yet (shown in the Log Out window)
         logoutSound: null,
         appsModalOpen: false,   // the Apps page inside the popup is loaded only while it is open
         appsWelcomeMode: false, // opened by itself after login (shows the welcome and "Don't show this again")
         hideAppsWelcome: false  // the "Don't show this again" box
      }
    },
    computed: {
      getPermissions(){
         return this.$store.state.permissions;
      },
      userName() {
         return this.$store.state.first_name;
      },
      roleName() {
         return this.$store.state.role_name || '';
      },
      // Apps menu item: ERP Developer (1) and Administrator (2) only, same as the server
      canManageModules() {
         let role = null;
         try { role = Number(JSON.parse(localStorage.getItem('roles'))); } catch (e) { role = null; }
         return [1, 2].includes(role);
      },
      // "Don't show this again" is saved per user on this browser
      appsWelcomeKey() {
         return `hide_apps_welcome_${this.userId}`;
      },
      userPic() {
         return this.$store.state.user_pic;
         //return localStorage.getItem('user_pic');
      },
      userId(){
         return this.$store.state.user_id;
      },      
      userLatitude(){
         return this.$store.state.latitude;
      },
      companyId() {
         return this.$store.state.company_id;
      },
      branchId() {
         return this.$store.state.branch_id;
      },
      selectedCompany() {
       return this.userCompanies.find(
         company => Number(company.id) === Number(this.selectedCompanyId)
       ) || null;
     },
     //selectedCompanyBranches
     selectedCompanyBranches() {
       if (!this.selectedCompany) {
           return [];
       }

       const branches = this.selectedCompany.branches || [];

       console.log("SELECTED COMPANY:", this.selectedCompany);
       console.log("BRANCHES:", branches);

       if (
           Number(this.selectedCompany.is_company_owner) === 1 &&
           branches.length > 1
       ) {

           return [
               {
                   id: null,
                   branch_name: 'All Branches',
                   is_all_branches: true
               },
               ...branches
           ];
       }

       return branches;
    }
    //End selectedCompanyBranches  

    },
    watch: {
      // Re-read after every page change (e.g. right after paying for an upgrade)
      $route() {
        this.loadSubscriptionAccess();
        this.syncMenuToRoute();
      },
      // Re-read right after a company/branch switch (new permissions arrive)
      "$store.state.permissions"() {
        this.loadSubscriptionAccess();
      },
    },
    created() {
      //alert(this.companyId);
    },
    mounted() {
      this.loadSubscriptionAccess();
      this.$router.isReady().then(() => this.syncMenuToRoute()); // after a reload the page address is known only then
      this.getUserCompanyBranchAssignments();
      this.logoutSound = new Audio('/sounds/messagebox.mp3');
      this.logoutSound.preload = 'auto';

      const logOutModal = document.getElementById('logOutModal');

      if (logOutModal) {
         logOutModal.addEventListener('show.bs.modal', this.playLogoutSound);
         logOutModal.addEventListener('show.bs.modal', this.countPendingSaves);
      }

      // Add apps popup: load the Apps page when it opens, unload it when it closes
      const appsModal = document.getElementById('addAppsModal');
      if (appsModal) {
         appsModal.addEventListener('show.bs.modal', () => { this.appsModalOpen = true; });
         appsModal.addEventListener('hidden.bs.modal', () => {
            this.appsModalOpen = false;
            this.appsWelcomeMode = false;
         });
      }

      // Welcome after login (until "Don't show this again" is ticked)
      this.$router.isReady().then(() => this.maybeShowAppsWelcome());
   },
  methods: {
    // Menu follows the page you are on (after a reload too): only that page's link is active,
    // and the groups holding it are opened, like SmartAdmin
    syncMenuToRoute() {
      this.$nextTick(() => {
        const sidebar = document.getElementById('sidebar');
        if (!sidebar) return;

        // The current page's address written the same way the menu links are (works with # addresses)
        const clean = (href) => (href || '').split('?')[0].replace(/\/+$/, '');
        const here = clean(this.$router.resolve(this.$route.path).href);
        let current = null;

        sidebar.querySelectorAll('a.nav-link:not([data-bs-toggle])').forEach((link) => {
          const href = link.getAttribute('href') || '';
          const isHere = href !== '' && href !== '#' && clean(href) === here;
          link.classList.toggle('active', isHere);
          if (isHere) current = link;
        });

        // Group headers are never "the current page" (they only open and close)
        sidebar.querySelectorAll('a.nav-link[data-bs-toggle="collapse"]').forEach((link) => {
          link.classList.remove('active');
        });

        if (!current || !window.bootstrap) return;

        // Open every group around the current page (innermost first, then its parents)
        let group = current.closest('.collapse');
        while (group) {
          if (!group.classList.contains('show')) {
            window.bootstrap.Collapse.getOrCreateInstance(group, { toggle: false }).show();
          }
          group = group.parentElement.closest('.collapse');
        }
      });
    },
    loadSubscriptionAccess() {
      try {
        this.subscriptionAccess = JSON.parse(localStorage.getItem('subscription_permissions')) || [];
      } catch (e) {
        this.subscriptionAccess = [];
      }
    },
    // true = the role allows it, but the package doesn't include it
    isLocked(permission) {
      return !this.subscriptionAccess.includes(permission);
    },
    showUserManagement() {
      // parent shows if ANY child permission exists
      return this.userManagementPermissions.some(perm =>
        this.getPermissions.includes(perm)
      );
    },
    showSubscription() {
      // parent shows if ANY child permission exists
      return this.subscriptionPermissions.some(perm =>
        this.getPermissions.includes(perm)
      );
    },
    showClients() {
      // parent shows if ANY child permission exists
      return this.clientsPermissions.some(perm =>
        this.getPermissions.includes(perm)
      );
    },
    showSettings() {
      // parent shows if ANY child permission exists
      return this.settingsPermissions.some(perm =>
        this.getPermissions.includes(perm)
      );
    },
    showSales() {
      // Demo: shown when the active company has the Sales module switched on (real pages come later)
      return (this.$store.state.modules || []).includes('sales');
    },
    showSamples() {
      // Module switched on for the company (Apps page) AND at least one Samples permission
      return (this.$store.state.modules || []).includes('samples')
        && this.samplesPermissions.some(perm => this.getPermissions.includes(perm));
    },
    showOrganisation() {
      // parent shows if ANY child permission exists
      return this.organisationPermissions.some(perm =>
        this.getPermissions.includes(perm)
      );
    },
    showDataLogs() {
      // parent shows if ANY child permission exists
      return this.dataLogsPermissions.some(perm =>
        this.getPermissions.includes(perm)
      );
    },
    // Top dropdowns: shown only when at least one group inside them is shown
    showAdministration() {
      return this.showOrganisation() || this.showUserManagement() || this.showSettings() || this.showDataLogs();
    },
    showPlatform() {
      return this.showSubscription() || this.showClients();
    },
    // Opens the Add apps popup. welcome = true: opened by itself after login
    openAppsModal(welcome = false) {
      this.appsWelcomeMode = welcome;
      const modal = document.getElementById('addAppsModal');
      if (modal && window.bootstrap) {
        window.bootstrap.Modal.getOrCreateInstance(modal).show();
      }
    },
    // Once per login, for Developer / Administrator, unless they ticked "Don't show this again"
    maybeShowAppsWelcome() {
      if (!this.canManageModules) return;

      let hidden = false;
      let shownThisLogin = false;
      try { hidden = localStorage.getItem(this.appsWelcomeKey) === '1'; } catch (e) { hidden = false; }
      try { shownThisLogin = sessionStorage.getItem('apps_welcome_shown') === '1'; } catch (e) { shownThisLogin = false; }
      if (hidden || shownThisLogin) return;

      try { sessionStorage.setItem('apps_welcome_shown', '1'); } catch (e) { /* private window: show anyway */ }
      this.hideAppsWelcome = false;
      setTimeout(() => this.openAppsModal(true), 600); // let the dashboard appear first
    },
    // "Don't show this again" ticked or unticked
    saveHideAppsWelcome() {
      try {
        if (this.hideAppsWelcome) {
          localStorage.setItem(this.appsWelcomeKey, '1');
        } else {
          localStorage.removeItem(this.appsWelcomeKey);
        }
      } catch (e) { /* storage blocked: it will just show again next login */ }
    },
    logOut(){
         const message = "You have been logged out Successfully!";
         const alertType = "success";
         this.$globalLogOut(alertType, message); 
    },
    NavigateToHome(){
        if (!localStorage.getItem('loggedIn')){
          emitter.emit('OnLogin', false)
          this.$router.push('/');
        } else {
          this.$router.push('/dashboard');
        }
      },
      NavigateToCrudTest(){
        if (!localStorage.getItem('loggedIn')){
          emitter.emit('OnLogin', false)
          this.$router.push('/');
        } else{
          this.$router.push('/crudtest');
        }
      },
      collapseNavbar() {
         if (window.innerWidth < 992) {
        const menuToggle = document.querySelector('#hide-menu a');
        if (menuToggle) {
          menuToggle.click();
        }
      }
      },
      // Log Out window: how many offline saves are still waiting
      async countPendingSaves() {
         this.pendingSaves = this.$offlineEnabled ? (await outboxItems()).length : 0;
      },
      playLogoutSound() {
         if (!this.logoutSound) return;

         this.logoutSound.pause();
         this.logoutSound.currentTime = 0;

         this.logoutSound.play().catch(error => {
            console.log('Logout sound could not be played:', error);
         });
      },
      async getUserCompanyBranchAssignments() {
  try {
    const formData = new FormData();

    formData.append('action', 'getUserCompanyBranchAssignments');

    const token = localStorage.getItem('jwt');
    const csrfToken = localStorage.getItem('csrf_token');

    const response = await axios.post(
      '/auth/api_auth.php',
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRF-TOKEN': csrfToken
        },
        withCredentials: true
      }
    );

    if (response.data.status === 'success') {


      this.userCompanies = response.data.results.companies || [];

      /*
       * Always use the active company from JWT/Vuex.
       * This makes the branch list correspond to the
       * currently active company when the dropdown opens.
       */
      this.selectedCompanyId =
        response.data.results.active_company_id ||
        this.companyId;

    } else {
      //alert(response.data);
      console.error(
        response.data.message || 'Unable to load companies and branches.'
      );
    }

  } catch (error) {
    console.error(
      'Error loading company and branch assignments:',
      error
    );
  }
},

toggleCompanyDropdown() {
  this.showCompanyDropdown = !this.showCompanyDropdown;

  if (this.showCompanyDropdown) {
    this.showBranchDropdown = false;

    /*
     * Start with the currently active company.
     */
    this.selectedCompanyId = this.companyId;
  }
},

toggleBranchDropdown() {
  this.showBranchDropdown = !this.showBranchDropdown;

  if (this.showBranchDropdown) {
    this.showCompanyDropdown = false;

    /*
     * Start with the currently active company.
     */
    this.selectedCompanyId = this.companyId;
  }
},

selectCompany(company) {
    this.selectedCompanyId = Number(company.id);

    /*
     * Do not change the JWT yet.
     * The user still needs to select a branch.
     */
    this.showCompanyDropdown = false;
    this.showBranchDropdown = true;
},

    async switchCompanyBranch(branch) {



        if (this.switchingCompanyBranch) {
            return;
        }

        const companyId = Number(this.selectedCompanyId);

        /*
         * All Branches has no actual branch ID.
         */
        const isAllBranches = branch.is_all_branches === true;

        const branchId = isAllBranches
            ? null
            : Number(branch.id);

        console.log('ALL BRANCHES TEST:', {
    isAllBranches: isAllBranches,
    branchId: branchId,
    vuexBranchId: this.branchId,
    results: branch
});

        if (!companyId) {
            return;
        }

        if (!isAllBranches && !branchId) {
            return;
        }

        /*
         * Already active - nothing to switch.
         */
        if (
            Number(this.companyId) === companyId &&
            (
                isAllBranches
                    ? this.branchId === null || this.branchId === undefined
                    : Number(this.branchId) === branchId
            )
        ) {
            this.showBranchDropdown = false;

            return;
        }

        this.switchingCompanyBranch = true;

        try {

            const formData = new FormData();

            formData.append('action', 'switchCompanyBranch');
            formData.append('company_id', companyId);

            /*
             * Only send branch_id when a specific branch
             * has been selected.
             */
            if (!isAllBranches) {
                formData.append('branch_id', branchId);
            }

            const token = localStorage.getItem('jwt');
            const csrfToken = localStorage.getItem('csrf_token');

            const response = await axios.post(
                '/auth/api_auth.php',
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'X-CSRF-TOKEN': csrfToken
                    },
                    withCredentials: true
                }
            );



            if (response.data.status === 'success') {

                const results = response.data.results;

                /*
                 * Replace the JWT with the new JWT containing
                 * the newly selected company and branch context.
                 */
                localStorage.setItem('jwt', results.token);
                localStorage.setItem('company_currency', results.company_currency || 'KES'); // the new company's money boxes
                this.$store.commit('SET_MODULES', results.modules || []); // the new company's modules


                /*
                 * Update Vuex active company/branch.
                 */
                this.$store.commit('setUserDetails', {
                    user: {
                        company_id: results.company_id,
                        company_name: results.company_name,
                        branch_id: isAllBranches ? null : Number(results.branch_id),
                        branch_name: isAllBranches ? 'All Branches' : results.branch_name
                    }
                });

                console.log('AFTER VUEX UPDATE:', {
                    isAllBranches: isAllBranches,
                    branchId: this.branchId
                });

                /*
                 * Close the dropdown.
                 */
                this.showCompanyDropdown = false;
                this.showBranchDropdown = false;

                sessionStorage.setItem(
                    'switching_company_branch',
                    'Switching Company & Branch...'
                );

                if (
                    this.$route.path === '/dashboard' ||
                    this.$route.path === '/dashboard/'
                ) {
                    emitter.emit('companyBranchSwitched');
                } else {
                    await this.$router.push('/dashboard');
                }

            } else {

                console.error(
                    response.data.message ||
                    'Unable to switch company and branch.'
                );
            }

        } catch (error) {

            console.error(
                'Error switching company and branch:',
                error
            );

        } finally {
            this.switchingCompanyBranch = false;
        }
    }

      //logOut
      /*logOut(){
         const message = "You have been logged out Successfully!";
         const alertType = "success";
         this.$globalLogOut(alertType, message);       
       }*/
      //End logOut
    }
};
</script>